import type { RoadMapData } from '../types/disclosure'

export const roadMapData: RoadMapData = {
  notesSection: {
    id: 'notes',
    number: 1,
    title: 'Notes',
    notes: [
      {
        id: 'roadmapNotes',
        label: 'Roadmap',
        api: 'Opportunity.Road_Map__c',
        value:
          'UWM Elite Conv 30 year fixed\n6.625% 2.25 BPC\n\nRate and term refinance, fiancé coming off title — no buyout\nProceeding DU which allows non-occupying co-borrower\nWill request CYP at disclosure',
      },
      {
        id: 'appraisalNotes',
        label: 'Appraisal Notes',
        api: 'Opportunity.Appraisal_Notes__c',
        value: 'Est Value: $600K\nDU no appraisal needed',
      },
      {
        id: 'incomeNotes',
        label: 'Income Notes',
        api: 'Opportunity.Income_Notes__c',
        value: 'Using B2 salary',
      },
      {
        id: 'assetNotes',
        label: 'Asset Notes',
        api: 'Opportunity.Asset_Notes__c',
        value: null,
      },
      {
        id: 'creditNotes',
        label: 'Credit Notes',
        api: 'Opportunity.Credit_Notes__c',
        value: 'Using Vantage 736 (756-20)\nDTI: 30.96/36.57',
      },
    ],
  },

  sections: [
    {
      id: 'disclosure-details',
      number: 2,
      title: 'Disclosure Details',
      groups: [
        {
          id: 'always-visible',
          title: 'Always Visible',
          fields: [
            { label: 'Channel', value: 'Wholesale', api: 'Channel__c', object: 'Opportunity' },
            { label: 'Designated Lender', value: 'UWM', api: 'imbus__Chosen_Lender__c', object: 'Opportunity' },
            { label: 'Lock Period', value: '30 Days', api: 'Lock_Period__c', object: 'Checklist__c' },
            { label: 'Closing Type', value: 'In-Person', api: 'ClosingType__c', object: 'Opportunity' },
            { label: 'Loan Source', value: 'Repeat Client', api: 'Loan_Source__c', object: 'Opportunity' },
            { label: 'Review LE & Pricing', value: 'Yes', api: 'ReviewLEAndPricing__c', object: 'Opportunity' },
            {
              label: 'Appraisal Order Status',
              value: 'Not Ordered',
              api: 'Appraisal_Order_Status__c',
              object: 'Opportunity',
              note: 'Display only — not round-tripped on save yet',
            },
            {
              label: 'Title Order Status',
              value: 'Ordered',
              api: 'Title_Order_Status__c',
              object: 'Opportunity',
              note: 'Display only — not round-tripped on save yet',
            },
            { label: 'Is a New Deed Required?', value: 'No', api: 'New_Deed__c', object: 'Checklist__c', type: 'yesno' },
            {
              label: 'Lock At Disclosure',
              value: 'No',
              api: 'Lock_at_Disclosure__c',
              object: 'Opportunity',
              type: 'yesno',
            },
            {
              label: 'Will this Loan receive compensation on both front and back via YSP?',
              value: 'No',
              api: 'Loan_Received_Compensation_via_YSP__c',
              object: 'Opportunity',
              type: 'yesno',
            },
            {
              label: 'Waive Underwriting Fee?',
              value: 'No',
              api: 'Waive_Underwriting_Fee__c',
              object: 'Checklist__c',
              type: 'yesno',
            },
            {
              label: 'New Construction?',
              value: 'No',
              api: 'New_Construction__c',
              object: 'Checklist__c',
              type: 'yesno',
            },
            {
              label: 'Prepayment Penalty Term',
              value: 'No Prepayment Penalty',
              api: 'Pre_Payment_penalty_duration__c',
              object: 'Checklist__c',
            },
            {
              label: 'Is there a pre-payment penalty?',
              value: 'No',
              api: 'Is_Prepayment_Penalty__c',
              object: 'Checklist__c',
              type: 'yesno',
              note: 'Derived from the prepayment term',
            },
            {
              label: 'Paystubs in 60 days of Disclosure Date?',
              value: 'Yes',
              api: 'Paystubs_in_60_days_of_Disclosure_Date__c',
              object: 'Checklist__c',
              type: 'yesno',
            },
            {
              label: 'Are you utilizing future income?',
              value: 'No',
              api: 'Are_you_utilizing_future_income__c',
              object: 'Checklist__c',
              type: 'yesno',
            },
            {
              label: 'Clearly Validated Offer Letter?',
              value: 'No',
              api: 'Is_Clearly_Validated_Offer_Letter__c',
              object: 'Checklist__c',
              type: 'yesno',
            },
            {
              label: 'Are any borrowers employed by family?',
              value: 'No',
              api: 'Are_any_borrowers_employed_by_family__c',
              object: 'Checklist__c',
              type: 'yesno',
            },
            {
              label: 'Do we have 2 Years Tax Returns?',
              value: 'No',
              api: 'Do_we_have_2_Years_Tax_Returns__c',
              object: 'Checklist__c',
              type: 'yesno',
            },
            {
              label: 'Appraisal Waiver?',
              value: 'No',
              api: 'Appraisal_Waiver_Requested__c',
              object: 'Checklist__c',
              type: 'yesno',
            },
            { label: 'Escrow Account', value: 'None Waived', api: 'imbus__Escrow_Account__c', object: 'Opportunity' },
            {
              label: 'Borrower Approved Cash at Closing',
              value: '$0.00',
              api: 'Borrower_Approved_Cash_at_Closing__c',
              object: 'Opportunity',
              type: 'currency',
            },
            {
              label: 'Boarded With Lender',
              value: 'No',
              api: 'BoardedWithLender__c',
              object: 'Opportunity',
              type: 'yesno',
            },
            {
              label: 'Confirm Lender Loan Number',
              value: '1226540085',
              api: 'imbus__Loan_Number__c',
              object: 'Opportunity',
            },
          ],
        },
        {
          id: 'poa-cema',
          title: 'POA & CEMA',
          description: 'Added 8/28.',
          fields: [
            { label: 'Power of Attorney (POA)', value: 'No', api: 'POA__c', object: 'Opportunity', type: 'yesno' },
            {
              label: 'CEMA',
              value: null,
              api: 'CEMA__c',
              object: 'Opportunity',
              note: 'New York subject properties only',
            },
          ],
        },
        {
          id: 'conditional-non-correspondent',
          title: 'Originator Compensation',
          condition: 'Channel ≠ Correspondent',
          fields: [
            {
              label: 'Originator Comp Type',
              value: 'Borrower Paid',
              api: 'Origination_Comp_Type__c',
              object: 'Checklist__c',
              note: 'No default is applied on correspondent loans',
            },
            {
              label: 'Origination Fee %',
              value: '2.25%',
              api: 'Origination_Fee__c',
              object: 'Checklist__c',
              note: 'Shown when Comp Type = Borrower Paid',
            },
          ],
        },
        {
          id: 'conditional-lock-period',
          title: 'Custom Lock Period',
          condition: 'Lock Period = Custom',
          applicable: false,
          applicabilityNote: 'Lock Period is 30 Days.',
          fields: [{ label: 'Custom Lock Period', value: null, api: 'Custom_Lock_Period__c', object: 'Checklist__c' }],
        },
        {
          id: 'conditional-correspondent',
          title: 'Correspondent Channel Fees',
          condition: 'Channel = Correspondent',
          applicable: false,
          applicabilityNote: 'Channel is Wholesale.',
          fields: [
            { label: 'Origination Fee %', value: null, api: 'Origination_Fee__c', object: 'Checklist__c' },
            {
              label: 'Discount Fee %',
              value: null,
              api: 'discountFeePercent',
              object: 'Checklist__c',
              note: 'Not mapped to save yet',
            },
          ],
        },
        {
          id: 'conditional-purchase',
          title: 'Purchase Transaction Details',
          condition: 'Loan Purpose = Purchase',
          applicable: false,
          applicabilityNote: 'Loan Purpose is Refinance.',
          fields: [
            {
              label: 'Mortgage Commitment Due',
              value: null,
              api: 'imbus__Mortgage_Commitment_Due__c',
              object: 'Opportunity',
            },
            {
              label: 'Is Buyer Paying Seller Transfer Tax?',
              value: null,
              api: 'Is_Seller_Transfer_Tax__c',
              object: 'Checklist__c',
            },
            {
              label: 'Is Buyer Paying Realtor Commission?',
              value: null,
              api: 'Is_Buyer_Paying_Realtor_Commission__c',
              object: 'Checklist__c',
            },
          ],
        },
        {
          id: 'conditional-purchase-yes',
          title: 'Transfer Tax & Realtor Commission',
          condition: 'Purchase + buyer paying transfer tax or commission',
          applicable: false,
          applicabilityNote: 'Loan Purpose is Refinance.',
          fields: [
            { label: 'Transfer Tax Amount', value: null, api: 'Transfer_Tax_Amount__c', object: 'Checklist__c' },
            { label: 'Realtor Commission', value: null, api: 'Realtor_Commission__c', object: 'Checklist__c' },
          ],
        },
      ],
    },
  ],
}
